import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'send-money',
      label: 'Send Money',
      description: 'Transfer funds internationally',
      icon: 'Send',
      variant: 'default',
      path: '/send-money-flow'
    },
    {
      id: 'add-recipient',
      label: 'Add Recipient',
      description: 'Add new beneficiary',
      icon: 'UserPlus',
      variant: 'outline',
      path: '/recipients-management'
    },
    {
      id: 'view-history',
      label: 'Transaction History',
      description: 'View all transactions',
      icon: 'History',
      variant: 'outline',
      path: '/transaction-history'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {quickActions?.map((action) => (
          <div key={action?.id} className="text-center">
            <Button
              variant={action?.variant}
              size="lg"
              fullWidth
              iconName={action?.icon}
              iconPosition="left"
              iconSize={20}
              onClick={() => navigate(action?.path)}
              className="mb-2"
            >
              {action?.label}
            </Button>
            <p className="text-xs text-muted-foreground">{action?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;